/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum EnrollmentTag {
  PENDING_CARRIER = 'PENDING_CARRIER',
  PENDING_EMPLOYEE = 'PENDING_EMPLOYEE',
  PENDING_EMPLOYER = 'PENDING_EMPLOYER',
  PENDING_AGENT = 'PENDING_AGENT',
  SUBMIT_FAILED = 'SUBMIT_FAILED',
  ADDRESS_ISSUE = 'ADDRESS_ISSUE',
  PM_IN_HANDLING = 'PM_IN_HANDLING',
  READY_TO_SUBMIT = 'READY_TO_SUBMIT',
  AOR_NEEDED = 'AOR_NEEDED',
  HSA_INSURANCE = 'HSA_INSURANCE',
  HOLD_APPLICATION = 'HOLD_APPLICATION',
}
